<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <header class="content__title pl-0">
            <h1>
                Fertilisers
            </h1>

            <div class="actions">
                <a class="btn btn-success btn--icon" @click.prevent="showCreateDialog"
                   v-b-tooltip.left title="Add new fertiliser"><i class="zmdi zmdi-plus"></i></a>
            </div>
        </header>

        <div class="card">
            <div class="bg-primary align-items-center d-flex">
                <h5 class="card-header text-white">
                    All Fertilisers
                </h5>
                <b-pagination align="right" class="my-auto mr-2 ml-auto"
                              :total-rows="pagination.total"
                              v-model="pagination.page"
                              :per-page="pagination.limit"
                />
            </div>
            <b-table hover stacked="md" :items="tableData" sort-by="name" :fields="table.fields"
                     :per-page="pagination.limit" :current-page="pagination.page" :sort-compare="$tableSortRoutine"
                     :show-empty="true">

                <template slot="is_liquid" slot-scope="data">
                    {{ data.item.is_liquid ? 'Liquid' : 'Solid' }}
                </template>

                <template slot="badges" slot-scope="data">
                    <span class="badge badge-danger" v-if="data.item.deleted_at">
                    Disabled
                    </span>
                </template>
                <template slot="actions" slot-scope="row">
                    <b-button @click="showEditDialog(row.item)" variant="secondary btn--icon" v-b-tooltip.hover="'Edit Fertiliser'">
                        <i class="zmdi zmdi-edit"></i>
                    </b-button>
                </template>
            </b-table>
        </div>
        <CreateModal :close="closeCreateDialog" v-model="creating" v-if="creating" />
        <EditModal :close="closeEditDialog" v-model="editingFertiliser" v-if="editingFertiliser" :fertiliser="editingFertiliser" />
    </div>
</template>

<script>
import listFertilisersQuery from '@views/Fertilisers/Browse/queryListFertilisers.graphql';
import startCase from 'lodash.startcase';
import CreateModal from './CreateModal';
import EditModal from './EditModal';

export default {
  name: 'BrowseFertilisers',
  apollo: {
    fertilisers: {
      query: listFertilisersQuery,
      variables: { input: { include_deleted: true } },
      manual: true,
      result({ data, loading }) {
        if (!loading) {
          this.fertilisers = data.filterFertilisers.data;
          this.pagination.total = data.filterFertilisers.meta.total;
        }
      },
    },
  },
  data() {
    return {
      fertilisers: [],
      editingFertiliser: null,
      creating: false,
      loading: 0,
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
      },
      table: {
        fields: [
          {
            key: 'name',
            label: 'Fertiliser',
            sortable: true,
          },
          {
            key: 'type',
            label: 'Fertiliser Type',
            formatter: startCase,
            sortable: true
          },
          {
            key: 'is_liquid',
            label: 'Fertiliser State',
            sortable: true,
          },
          {
            key: 'badges',
            label: 'Statuses',
          },
          {
            key: 'actions',
            label: '',
            tdClass: 'text-right',
          },
        ],
      },
    };
  },
  computed: {
    tableData() {
      return this.fertilisers;
    },
  },
  methods: {
    showEditDialog(fertiliser) {
      this.editingFertiliser = fertiliser;
    },
    closeEditDialog() {
      this.editingFertiliser = null;
    },
    showCreateDialog() {
      this.creating = true;
    },
    closeCreateDialog() {
      this.creating = false;
    },
  },
  components: {
    EditModal,
    CreateModal,
  },
};
</script>
